var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"ibox float-e-margins"},[_c('div',{staticClass:"ibox-content"},[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-spinner fa-pulse"}),_vm._v(" Carregando...\n      ")])])])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1931f48e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./FrontEnd/componentes/Carregando.vue
// module id = 1903
// module chunks = 0